import { Node, mergeAttributes } from '@tiptap/core';

import { AGREEMENT_VARIABLE_LABELS } from './agreement-variables';

// atomic inline chip for agreement variables — users insert it from the toolbar
// dropdown and can delete but never edit it, so variable keys cannot be mistyped
export const VariableNode = Node.create({
  name: 'variable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      key: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-variable') || '',
        renderHTML: (attributes) => ({ 'data-variable': attributes.key }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-variable]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: 'agreement-variable' }),
      AGREEMENT_VARIABLE_LABELS[node.attrs.key] ?? node.attrs.key,
    ];
  },
});
